import axios from "axios";

const API_URL = "/api/import";

export const getImportModules = async () => {
  const res = await axios.get(`${API_URL}/modules`);
  return res.data;
};

/** Triggers a browser download of the template for a module. */
export const downloadTemplate = async (moduleKey, format = "xlsx") => {
  const res = await axios.get(`${API_URL}/${moduleKey}/template`, {
    params: { format },
    responseType: "blob",
  });

  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement("a");
  link.href = url;
  link.download = `${moduleKey}-import-template.${format}`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

/** Dry run — returns a per-row preview without writing anything. */
export const validateImport = async (moduleKey, file) => {
  const form = new FormData();
  form.append("file", file);
  const res = await axios.post(`${API_URL}/${moduleKey}/validate`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

/** Writes the valid rows. The same file is re-sent and re-validated server-side. */
export const commitImport = async (moduleKey, file, { skipInvalid = false } = {}) => {
  const form = new FormData();
  form.append("file", file);
  form.append("skipInvalid", skipInvalid ? "true" : "false");
  const res = await axios.post(`${API_URL}/${moduleKey}/commit`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};
